import { cn } from "@/lib/utils";
import { ReactNode } from "react";
interface SectionHeadingProps {
  children: ReactNode;
  subtitle?: ReactNode;
  className?: string;
  align?: "left" | "center" | "right";
}
export function SectionHeading({
  children,
  subtitle,
  className,
  align = "center"
}: SectionHeadingProps) {
  return <div className={cn("mb-12", align === "center" && "text-center", align === "right" && "text-right", className)}>
      <h2 className="font-serif text-2xl sm:text-3xl md:text-page-title text-foreground">
        {children}
      </h2>
      {subtitle

    }
      <div className={cn("mt-6 h-px w-24 bg-gradient-to-r from-transparent via-gold to-transparent", align === "center" && "mx-auto", align === "right" && "ml-auto")} />
    </div>;
}